import { IFazenda, RolesProps, UserProps } from '@dinnisoft/esteio-gestao-common';
import { signIn, signOut, emailValidate } from 'api/api';
import {
  LoginPayloadRequestDTO,
  ValidateEmailPayloadRequestDTO,
  ValidateEmailResponseDTO,
} from 'dtos/AuthenticationDTO';
import { getSlugFromURL } from 'utils/whiteLabel';

import {
  DATABASE_SELECTED,
  FAZENDA,
  PROJECT_SELECTED,
  ROLE_SELECTED,
  ROLES_KEY,
  TOKEN_KEY,
  USER_KEY,
} from '../constants';

export const isAuthenticated = (): boolean => localStorage.getItem(TOKEN_KEY) !== null;

export const getToken = (): string | null => localStorage.getItem(TOKEN_KEY);

export const getRoleSelected = (): any => localStorage.getItem(ROLE_SELECTED);

export const getSlugSelected = (): string => {
  return getSlugFromURL();
};

export const getProjectSelected = (): string | null => localStorage.getItem(PROJECT_SELECTED);

export const getDatabaseSelected = (): string | null => localStorage.getItem(DATABASE_SELECTED);

export const getSelectedFazenda = (): IFazenda =>
  JSON.parse(sessionStorage.getItem('fazenda') || '{}');

export const getUser = (): UserProps => {
  const userSaved = localStorage.getItem(USER_KEY);
  return userSaved ? JSON.parse(userSaved) : null;
};

export const getRoles = (): RolesProps[] => {
  const savedRoles = localStorage.getItem(ROLES_KEY);
  const jsonRoles: RolesProps[] = savedRoles ? JSON.parse(savedRoles) : [];

  // const hasRole = (role_id: number) => jsonRoles.some((role: RolesProps) => role.id === role_id);

  // return jsonRoles.filter((role) => {
  //   if (hasRole(Roles.admin) && role.id === Roles.cliente) return false;
  //   if (hasRole(Roles.validador) && role.id === Roles.validador) return false;
  //   return true;
  // });
  return jsonRoles;
};

const clearLocalStorage = (): void => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(ROLES_KEY);
};

const clearSessionStorage = (): void => {
  sessionStorage.removeItem(FAZENDA);
};

export const validateEmail = async ({
  email,
  reToken,
}: ValidateEmailPayloadRequestDTO): Promise<ValidateEmailResponseDTO[]> => {
  try {
    const { data } = await emailValidate({ email, reToken });

    if (data?.convenios) {
      return data.convenios;
    }

    return [];
  } catch (error) {
    console.error('Error during validateEmail:', error);
    return [];
  }
};

export const login = async ({
  email,
  password,
  reToken,
}: LoginPayloadRequestDTO): Promise<boolean> => {
  try {
    const { data } = await signIn({ email, password, reToken });

    if (data.auth) {
      localStorage.setItem(TOKEN_KEY, data.token);
      localStorage.setItem(USER_KEY, JSON.stringify(data.user));
      localStorage.setItem(ROLES_KEY, JSON.stringify(data.roles));
      return true;
    }

    clearLocalStorage();
    return false;
  } catch (error) {
    console.error('Error during login:', error);
    clearLocalStorage();
    return false;
  }
};

export const logout = async (): Promise<boolean> => {
  try {
    const { data } = await signOut();

    clearLocalStorage();
    clearSessionStorage();

    return !data.auth;
  } catch (error) {
    console.error('Error during logout:', error);
    clearLocalStorage();
    return false;
  }
};
